module.exports = __webpack_public_path__ + "/images/logo-af-hm.5b6441f.svg";